module.exports = new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      const resolvedHost = urlParams.get('panelChatbot') ?? 'https://panel-chatbot.thoughtriver.com';
      console.log('panelChatbot', 'Resolved host:', resolvedHost);
      const resolvedUrl = `${resolvedHost}/remoteEntry.js`;

      const script = document.createElement('script');
      script.src = resolvedUrl;
      script.onload = () => {
        const proxy = {
          get: (request) => window['panelChatbot'].get(request),
          init: (...args) => {
            try {
              return window['panelChatbot'].init(...args);
            } catch (e) {
              console.log('Remote container already initialized');
            }
          },
        }
        resolve(proxy);
      }

      document.head.appendChild(script);
    });